import { render, staticRenderFns } from "./OrderAlerts.vue?vue&type=template&id=6466266e&"
import script from "./OrderAlerts.js?vue&type=script&lang=js&"
export * from "./OrderAlerts.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports